import React from 'react';
import { FormBuilder } from 'commons-ui';
import useClone from './useClone';
import { NOTICE_FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, noticeValidationSchema } from '../../utils/formConfig';

const CloneNotice: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useClone();

	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={noticeValidationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={NOTICE_FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
			dependencies={[]}
		/>
	);
};

export default CloneNotice;
